module.exports = __webpack_public_path__ + "static/media/logotype.901a990a.svg";